


















































































import {Component, Prop, Vue} from 'vue-property-decorator';

import { curPref, Preferences } from '@/services/Preferences';
import { Device } from '@/types/core';

import { DateTime } from 'luxon';
import { DevicePage, DeviceService, curDeviceService } from '@/services/DeviceService';

import OptionList from '@/components/OptionList.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import DeviceRow from '@/components/device/DeviceRow.vue';
import DeviceRowMobile from "@/components/device/DeviceRowMobile.vue";
import VueError from '@/components/VueError.vue';
import PageNav from '@/components/PageNav.vue';
import NavBar from '@/components/NavBar.vue';
import EnrolDevice from '@/components/device/EnrolDevice.vue';
import tippy from "tippy.js";
import NumEntries from '@/components/NumEntries.vue';
import { CsvUtil } from '@/util/CsvUtil';
import _ from 'lodash';
import moment from 'moment';
import fileDownload from 'js-file-download';
import {curGroupService} from "@/services/GroupService";


@Component({
  components: {
    DeviceRow,
    DeviceRowMobile,
    OptionList,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar,
    EnrolDevice,
    NumEntries
  },
})
export default class DeviceList extends Vue {

  @Prop({ default: '', type: String}) externalSearchTerms!: string;

  // our model
  dateTime = DateTime;
  curOrderBy = curPref.retrieve('v3-devices-cur-order', 'deviceId');
  curAscDesc = curPref.retrieve('v3-devices-cur-asc-desc', 'asc');
  searchTerm = curPref.retrieve('v3-devices-search-term', '');
  pageSize = 20;
  error:string = '';
  // first move is always to refresh Data
  httpBusy:boolean = true;
  pageList:DevicePage[] = [];
  curPage:DevicePage = {} as DevicePage;
  reqNo:number = 0;

  status:'view-all'|'enrol-device'|'unenrol-device'|'configure-devices' = 'view-all';
  selectedDevice:Device = {} as Device;

  public $refs!: {
    'search-box': SearchBox
  };
  
  // internal dependencies
  private deviceService:DeviceService = curDeviceService;
  private csvUtil:CsvUtil = new CsvUtil()

  async mounted() {

    if (this.externalSearchTerms && this.externalSearchTerms.length > 2) {
      this.searchTerm = this.externalSearchTerms;
      curPref.store('v3-devices-search-term', this.searchTerm);
    }
    this.refreshData();

    // v-if impeding tippy
    await this.$nextTick()
    tippy('[data-tippy-content]');
  }
  
  changeStatus(newStatus:'view-all'|'enrol-device'|'unenrol-device'|'configure-devices', selectedDevice?:Device) {
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if (newStatus === 'configure-devices') {
      this.$router.push({
        name: 'configure-devices',
        params: {
          groupId: this.commonGroup()[0],
        },
      });
    }

    if(selectedDevice)
      this.selectedDevice = selectedDevice;
  }

  async refreshData() {

    this.error = '';
    this.httpBusy = true;

    // prevents unwanted effects from race conditions now the search bar hangs around
    const currentReq:number = this.reqNo + 1;
    this.reqNo = currentReq;

    const reply = await this.deviceService.getDevices({
        orderBy:this.curOrderBy, 
        ascDesc:this.curAscDesc, 
        pageSize:this.pageSize,
        filter: this.searchTerm});

    // if this request has not been superceded then continue
    if (currentReq !== this.reqNo) {
      return
    }

    this.httpBusy = false;

    if (reply.httpCode === 403)
      return this.$router.push({name: 'login'});

    if (reply.errorMsg)
      return this.error = `Unable to load devices because ${reply.errorMsg}`;

    this.pageList = reply.devicePageList as DevicePage[];

    // we set the current page
    if (this.pageList.length > 0)
      this.curPage = this.pageList[0];

  }

  newOrderBy(newOrderBy:{orderBy:string, ascDesc:string}) {
    
    curPref.store('v3-devices-cur-order', newOrderBy.orderBy);
    curPref.store('v3-devices-cur-asc-desc', newOrderBy.ascDesc);

    this.curOrderBy = newOrderBy.orderBy;
    this.curAscDesc = newOrderBy.ascDesc;

    this.refreshData();
  }

  newSearchText(newSearchText:string) {

    // we check if the text matches the required regex
    if(newSearchText.trim() !== "" && !/^([a-z0-9\.-]{3,30})(\s[a-z0-9\.-]{3,30})*$/i.test(newSearchText))
      return;

    curPref.store('v3-devices-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  exportList() {

    let allDeviceList = _.flatten(this.pageList.map(page => page.deviceList))
      
    let csvExport = this.csvUtil.deviceListToCsv(allDeviceList);

    let filename = `export-devices-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  get showPageNav():boolean {
    return !this.httpBusy && this.pageList.length > 0 && this.error === '';
  }

  get showDeviceRows():boolean {
    return !this.httpBusy && this.pageList.length > 0 && this.error === '';
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get showNoApiKeys():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm === '' && this.error === '';
  }

  get numEntries():number {
    return this.pageList.map(page => page.deviceList.length).reduce((acc, current) => acc+current, 0);
  }

  get showNumEntries():boolean {
    return !this.httpBusy;
  }

  get numEntriesExactNumber():boolean {
    return this.searchTerm === '';
  }

  get canConfigureDevices():boolean {
    const allDevices = _.flatMap(this.pageList, (page) => _.map(page.deviceList, device => device));
    return curGroupService.canConfigureDevices(allDevices);
  }

  commonGroup():string[] {
    const allDevices = _.flatMap(this.pageList, (page) => _.map(page.deviceList, device => device));
    return curGroupService.commonGroup(allDevices);
  }
  
}
